import { render } from "./BlockText.vue?vue&type=template&id=aa07ec94"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"

import "@/components/block-text/block-text.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__